import { Component, OnInit } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
  currentYear: number;
  hideFooter: boolean = false;
  constructor() {
    this.currentYear = (new Date()).getFullYear();
    this.hideFooter = window.location.host.includes('duracellpowercenter');
  }

  ngOnInit(): void {
  }

}
